module.exports = __webpack_public_path__ + "static/media/handIcon.a598d266.png";